import { render } from "./PanelCard.vue?vue&type=template&id=8eaa262c&scoped=true"
import script from "./PanelCard.vue?vue&type=script&lang=js"
export * from "./PanelCard.vue?vue&type=script&lang=js"

import "@/Common/Styles/nftCard.scss?vue&type=style&index=0&id=8eaa262c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eaa262c"]])

export default __exports__